import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { getCurrentDateTime } from '../../../../../utils';
import { useLocation, useParams } from 'react-router-dom';

const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  departmentHeading: {
    fontSize: 14,
    fontWeight: 'bold',
    marginVertical: 10
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const groupByDepartment = (data) => {
  return data.reduce((acc, item) => {
    const departmentName = item.opd.department.department;
    if (!acc[departmentName]) {
      acc[departmentName] = {
        patients: [],
        totalNetAmount: 0
      };
    }
    acc[departmentName].patients.push(item);
    acc[departmentName].totalNetAmount += item.opd.total;
    return acc;
  }, {});
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const DepartmentWiseOpdReportPdf = ({ data }) => {
  console.log('hello Consultant', data);
  const groupedData = groupByDepartment(data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Department Wise Opd Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <Text style={{ fontSize: '8px' }} content={`From Date : ${data.from_date} To Date :${data.to_date}`} />
            {Object.keys(groupedData).map((departmentName) => (
              <View key={departmentName}>
                <Text style={styles.departmentHeading} content={` ${departmentName}`} />
                <Text
                  style={{ fontSize: '8px' }}
                  content={`Total Net Amount: ${groupedData[departmentName].totalNetAmount}`}
                />

                <View style={styles.row}>
                  <Text style={{...styles.columnHeader, width: '8%'}} content="Sr." />
                  <Text style={styles.columnHeader} content="Reg. Date" />
                  <Text style={styles.columnHeader} content="MR No." />
                  <Text style={styles.columnHeader} content="Patient ID" />
                  <Text style={{...styles.columnHeader, width: '20%'}} content="Patient Name" />
                  <Text style={styles.columnHeader} content="Age" />
                  <Text style={styles.columnHeader} content="Gender" />
                  <Text style={{...styles.columnHeader, width: '20%'}} content="Guardian Name" />
                  <Text style={{...styles.columnHeader, width: '20%'}} content="Address" />
                  <Text style={styles.columnHeader} content="Department" />
                  <Text style={styles.columnHeader} content="New/Revisit Patient" />
                </View>
                {groupedData[departmentName].patients.map((item, index) => (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={{...styles.columnContent, width: '8%'}} content={index + 1} />
                    <Text style={styles.columnContent} content={formatDate(item.opd.date)} />
                    <Text style={styles.columnContent} content="" />
                    <Text style={styles.columnContent} content={item.opd.uhid} />
                    <Text style={{...styles.columnContent, width: '20%', textAlign: 'left'}}
                      content={`${item.opd.name_suffix} ${item.opd.first_name} ${item.opd.last_name}`} />
                    <Text style={styles.columnContent}
                      content={new Date().getFullYear() - new Date(item.opd.dob).getFullYear()} />
                    <Text style={styles.columnContent} content={item.opd.gender} />
                    <Text style={{...styles.columnContent, width: '20%', textAlign: 'left'}} content={item.opd.guardian_name} />
                    <Text style={{...styles.columnContent, width: '20%', textAlign: 'left'}} content={item.opd.address.address} />
                    <Text style={styles.columnContent} content={item.opd.department.department} />
                    <Text style={styles.columnContent} content={item.opd.visit_no} />
                  </View>
                ))}
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default DepartmentWiseOpdReportPdf;
